import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { RotateCcw, GitCompare } from "lucide-react";
import { TEMPLATES } from "@/constants/testIds";

export function VersionsSheet({ open, onOpenChange, versions, onRestore, onCompare }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="bg-white sm:max-w-lg overflow-auto">
        <SheetHeader>
          <SheetTitle>Historial de versiones</SheetTitle>
        </SheetHeader>
        <div className="mt-6 space-y-3">
          {versions.map((v) => (
            <div key={v.id} className="border border-slate-200 rounded-md p-3">
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <Badge className="bg-orange-100 text-orange-700 hover:bg-orange-100 border-orange-200">
                      v{v.version}
                    </Badge>
                    <span className="text-sm text-slate-700">{v.name}</span>
                  </div>
                  <div className="text-xs text-slate-500 mt-1">
                    {new Date(v.created_at).toLocaleString("es")} · {v.created_by || "sistema"}
                  </div>
                  <div className="text-xs text-slate-600 mt-1 italic">
                    "{v.change_note || "Sin nota"}"
                  </div>
                </div>
                <div className="flex flex-col gap-1.5">
                  {v.version !== versions[0]?.version && (
                    <Button size="sm" variant="outline" onClick={() => onCompare(v.version)}
                      className="border-slate-200 hover:bg-orange-50 hover:text-orange-700 hover:border-orange-200"
                      data-testid={TEMPLATES.compareBtn(v.version)}>
                      <GitCompare className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} />
                      Comparar
                    </Button>
                  )}
                  <Button size="sm" variant="outline" onClick={() => onRestore(v.version)}
                    className="border-slate-200 hover:bg-orange-50 hover:text-orange-700 hover:border-orange-200"
                    data-testid={TEMPLATES.restoreBtn(v.version)}>
                    <RotateCcw className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} />
                    Restaurar
                  </Button>
                </div>
              </div>
            </div>
          ))}
          {versions.length === 0 && (
            <div className="text-sm text-slate-400 text-center py-8">Sin versiones anteriores.</div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
